import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Infrastructure from './components/Infrastructure'; // NOVO
import FAQ from './components/FAQ'; // NOVO
import Footer from './components/Footer';

function App() {
  return (
    <div className="font-sans text-slate-800 bg-gray-50">
      <Navbar />
      <Hero />
      <Features />        {/* Fundo Cinza Claro (Padrão do componente) */}
      <Infrastructure />  {/* Fundo Branco */}
      <FAQ />             {/* Fundo Cinza Claro */}
      <Footer />
    </div>
  );
}

export default App;